<div class="plans-section">
  <div class="plans-shell">

    <!-- Basic -->
    <div class="plan-card">
      <h3 class="plan-name">Basic</h3>
      <div class="plan-price">
        <span class="plan-amount">{{ isYearly ? '50k' : '5k' }}</span>
        <span class="plan-currency">PKR</span>
        <span class="plan-period">{{ isYearly ? '/Year' : '/Month' }}</span>
      </div>
      <ul class="plan-features">
        <li><strong>5 apps</strong>, unlimited users</li>
      </ul>
      <div class="plan-actions">
        <a
          class="plan-btn plan-btn--primary"
          routerLink="/buy-now"
          [queryParams]="{ plan: 'Basic', cycle: isYearly ? 'Yearly' : 'Monthly' }"
        >Buy Now</a>
        <a class="plan-btn plan-btn--secondary" routerLink="/product">Free Trial</a>
      </div>
    </div>

    <!-- Standard -->
    <div class="plan-card">
      <h3 class="plan-name">Standard</h3>
      <div class="plan-price">
        <span class="plan-amount">{{ isYearly ? '100k' : '10k' }}</span>
        <span class="plan-currency">PKR</span>
        <span class="plan-period">{{ isYearly ? '/Year' : '/Month' }}</span>
      </div>
      <ul class="plan-features">
        <li>All apps</li>
      </ul>
      <div class="plan-actions">
        <a
          class="plan-btn plan-btn--primary"
          routerLink="/buy-now"
          [queryParams]="{ plan: 'Standard', cycle: isYearly ? 'Yearly' : 'Monthly' }"
        >Buy Now</a>
        <a class="plan-btn plan-btn--secondary" routerLink="/product">Free Trial</a>
      </div>
    </div>

    <!-- Custom -->
    <div class="plan-card">
      <h3 class="plan-name">Custom</h3>
      <div class="plan-price">
        <span class="plan-amount">10k</span>
        <span class="plan-currency">PKR</span>
        <span class="plan-period">/Month</span>
      </div>
      <ul class="plan-features">
        <li>All apps</li>
        <li>Multi company</li>
        <li>External API</li>
        <li>+ customization charges apply</li>
      </ul>
      <div class="plan-actions">
        <a
          class="plan-btn plan-btn--primary"
          routerLink="/buy-now"
          [queryParams]="{ plan: 'Custom', cycle: isYearly ? 'Yearly' : 'Monthly' }"
        >Buy Now</a>
        <a class="plan-btn plan-btn--secondary" routerLink="/product">Free Trial</a>
      </div>
    </div>

  </div>
</div>
